import { Loader2 } from "lucide-react";

export function Loader({ label = "Chargement…" }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-stone-400 gap-3" data-testid="loader">
      <Loader2 className="w-6 h-6 animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function Skeleton({ className = "" }) {
  return <div className={`animate-pulse rounded-xl bg-stone-200/60 ${className}`} />;
}

export function EmptyState({ icon: Icon, title, description, action, testid = "empty-state" }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6" data-testid={testid}>
      {Icon && (
        <div className="w-14 h-14 rounded-2xl bg-accent flex items-center justify-center mb-4">
          <Icon className="w-6 h-6 text-stone-700" />
        </div>
      )}
      <h3 className="font-serif text-xl text-stone-900">{title}</h3>
      {description && <p className="text-sm text-stone-500 mt-2 max-w-sm">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 animate-fade-up">
      <div>
        {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
        <h1 className="font-serif text-3xl lg:text-4xl tracking-tight text-stone-900">{title}</h1>
        {description && <p className="text-stone-500 mt-2 max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, sub, accent = "stone", icon: Icon, testid }) {
  const accents = {
    stone: "text-stone-900", sage: "text-sage", champagne: "text-champagne",
    destructive: "text-destructive", amber: "text-amber-600",
  };
  return (
    <div className="card-lux p-5" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div className="eyebrow">{label}</div>
        {Icon && <Icon className="w-4 h-4 text-stone-400" />}
      </div>
      <div className={`font-mono text-2xl lg:text-3xl mt-3 font-medium ${accents[accent]}`}>{value}</div>
      {sub && <div className="text-xs text-stone-500 mt-1">{sub}</div>}
    </div>
  );
}
